
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getMovieList, getOneMovieData } from '../../actions/movielist-actions'
import { appHeightChanged } from '../../actions/app-actions'
import { useHistory } from 'react-router-dom'
import EbilletProgram from './components/EbilletProgram'
import moment from 'moment'
import EbilletMovieContainer from './EbilletMovieContainer'


class EbilletFilmDetails extends React.Component {
    constructor() {
        super();
        this.state = {
            movie: {},
            allEvents: [],
            allLocations:[],
            allMovieBases: [],
            allOrganizers: [],
            allEventsTypes:[]
        }

    }
    componentDidMount() {
        const { actions, movies, organizerIds, iframeId } = this.props
        if (window.parent != window) actions.appHeightChanged(iframeId, true);
        const search = window.location.search;
    
        const paramss = new URLSearchParams(search);
        let movieId = paramss.get('movieid')
      
        actions.getMovieList(3);
     
      
      
        fetch(`https://bio.ebillet.dk/systemnative/export.asmx/GetEventsALLJson?Key=RGVubmUgdG9rZW4gZ2l2ZXIgYWRnYW5nIHRpbCBhbGxlIGZvcmVzdGlsbGluZ2Vy&Debug=0&ForceLoad=0&prettyJSON=0&GetCasheLoadTimes=0&movieId=${movieId}`)
            .then(res => res.json())
            .then(result => {
                this.setState({ movie: result.movies[0] })
                this.setState({ allEvents: result.events })
                this.setState({ allLocations: result.locations })
                this.setState({ allMovieBases: result.movieBases })
                this.setState({ allOrganizers: result.organizers })
                this.setState({ allEventsTypes: result.eventTypes })

              
            })
    }

    componentWillUnmount() {
        const { actions, iframeId } = this.props;
        if (window.parent != window) actions.appHeightChanged(iframeId,  true);
        else sessionStorage.setItem("scroll-position", window.scrollY);
    }

  
    render() {
        const { ageCensor, actions, iframeId,  backTo} = this.props;
    
        const { allEvents, allLocations, allMovieBases, allOrganizers, allEventsTypes, movie } = this.state
       
        return (
            <>
                { /*allLocations && allMovieBases && allOrganizers && allEventsTypes &&*/ movie ?
                   
            <EbilletMovieContainer
                allEvents={allEvents}
                allOrganizers={allOrganizers}
                locations={allLocations}
                movie={movie }
                allEventsTypes={allEventsTypes}
                allMovieBases={allMovieBases}
                appHeightChanged={actions.appHeightChanged}
                iframeId={iframeId}
                />
                    : <div className="spinner"></div>
                }
            </>
         )
    }
}

const mapStateToProps = (state, ownProps) => {
  
    return {
        iframeId: state.app.iframeId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { appHeightChanged, getMovieList }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EbilletFilmDetails)